import { useEffect, useState } from "react";
import { GenerateDocketColumnDefinition } from "../../../../../components/stateful/table/TableHelper";
import { ConstructEmptyDocketRow } from "../../../../../utilities/interfaces/DocketRow";
import { useAppDispatch, useAppSelector } from "../../../../../app/hooks";
import { getDocketRows } from "../../../../../features/state/StateDocket-slice";
import { GridRowClickEvent } from "@progress/kendo-react-grid";
import { docketApi } from "../../../../../utilities/api/docketApi";
import { getAllPublicCms, updateCmsItem } from "../../../../../features/public/publicCms-slice";
import { CmsItemType } from "../../../../../utilities/enums/CmsItemType";
import { CmsItem } from "../../../../../utilities/interfaces/CmsItem";
import { useNotificationHelper } from "../../../../../utilities/helpers/NotificationHelper";
import { CheckIfAdminUser } from "../../../../../utilities/helpers/AccountInfoHelper";

export const usePublicProposedController = () => {

  const dispatch = useAppDispatch();

  //#region table data

  //redux
  const values = useAppSelector((state) => state.docket.rows);
  const fetchingValues = useAppSelector((state) => state.docket.fetchingRows);

  //state
  const [columnData, setColumnData] = useState<any>([]);

  useEffect(() => {
    if (values.length < 1) {
      dispatch(getDocketRows());
    }

    if (columnData.length < 1) {
      generateColumnData();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const generateColumnData = async () => {
    setColumnData(await GenerateDocketColumnDefinition(ConstructEmptyDocketRow()));
  }

  const [selectedFilingId, setSelectedFilingId] = useState<any>();

  const onRowClick = (event: GridRowClickEvent) => {
    toggleDocketDetails(event.dataItem.filingId);
    setSelectedFilingId(event.dataItem.filingId);
  }

  //#endregion

  //#region docket details dialog

  const [docketDetailsOpen, setDocketDetailsOpen] = useState<boolean>(false);

  const toggleDocketDetails = (newSelectedDocketId?: number) => {
    if (!docketDetailsOpen && !!newSelectedDocketId) {
      fetchDocketDetails(newSelectedDocketId);
      setDocketDetailsOpen(!docketDetailsOpen);
    }

    if (docketDetailsOpen) {
      setDocketDetails(undefined);
      setDocketDetailsOpen(!docketDetailsOpen);
    }

  }

  const [docketDetails, setDocketDetails] = useState<any>();

  const fetchDocketDetails = async (docketId: number) => {
    let newDocketDetails = await docketApi.getDocketDetail(docketId);
    setDocketDetails(newDocketDetails);
  }

  //#endregion

  //#region cmsitem

  //#region redux state
  const cmsValues: CmsItem[] = useAppSelector((state) => state.publicCms.cmsItems);
  const [docketCmsItem, setDocketCmsItem] = useState<any>();
  const [selectedCmsItem, setSelectedCmsItem] = useState<any>();
  const [editCmsOpen, setEditOpen] = useState<boolean>(false);
  const [cmsText, setCmsText] = useState<string>();
  const [cmsTitle, setCmsTitle] = useState<string | null>();
  const [isAdmin, setIsAdmin] = useState<boolean>(false);
  //#endregion

  //#region notification helper
  const { addNotification } = useNotificationHelper();

  // switches to the edit view
  const toggleCmsEdit = () => {
    editCmsOpen ? setEditOpen(false) : setEditOpen(true);
  };

  const handleCmsItemClick = (id: number) => {
    // get cmsItem text and title
    let cmsIndex = cmsValues.findIndex((cmsData) => cmsData.id === id);
    const cmsItem: CmsItem = cmsValues[cmsIndex];
    setSelectedCmsItem(cmsItem);
    setCmsText(cmsItem!.cmsItemValue);
    setCmsTitle(cmsItem!.cmsItemName);
    toggleCmsEdit();
  };

  const getAllCmsItems = () => {
    dispatch(getAllPublicCms());
  };

  const onCmsItemSave = async (cmsItemText: string) => {
    let cmsItem = { ...selectedCmsItem, cmsItemValue: cmsItemText, cmsTypeId: CmsItemType.Html };
    dispatch(updateCmsItem(cmsItem))
      .unwrap()
      .then(() => {
        addNotification({
          type: 'success',
          message: `${cmsItem.cmsItemName} was saved successfully`,
        });
        toggleCmsEdit();
      })
      .catch((error: any) => {
        addNotification({
          type: 'error',
          message: `${cmsItem.cmsItemName} was unable to save. ${error.message}`,
        });
      });
  };

  useEffect(() => {
    if (cmsValues.length < 1 && !docketCmsItem) {
      getAllCmsItems();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (cmsValues.length > 0 && !docketCmsItem) {
      for (var i = 0; i < cmsValues.length; i++) {
        if (cmsValues[i].cmsItemName === 'Docket Link') {
          setDocketCmsItem(cmsValues[i]);
          let isAdminUser = CheckIfAdminUser();
          setIsAdmin(isAdminUser);
        }
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cmsValues]);

  useEffect(() => {
  }, [docketCmsItem])

  //#endregion

  return {
    //redux
    values,
    fetchingValues,
    //values
    columnData,
    docketDetails,
    docketDetailsOpen,
    selectedFilingId,
    editCmsOpen,
    cmsTitle,
    isAdmin,
    docketCmsItem,
    cmsText,
    //functions
    onRowClick,
    toggleDocketDetails,
    toggleCmsEdit,
    handleCmsItemClick,
    onCmsItemSave,
  }
}